import DocumentAccordion from "@root/modules/DocumentsPage/DocumentAccordion";
import ViewDocument from "@root/modules/DocumentsPage/ViewDocument";
var DocumentFilter = /** @class */ (function () {
    function DocumentFilter() {
        this.documentPage = document.querySelector('.documents-page');
        this.searchContainer = this.documentPage.querySelector('[data-search-input]');
        this.searchInput = this.searchContainer.querySelector('input');
        this.searchSubmitButton = this.searchContainer.querySelector('button');
        this.documentTypes = this.documentPage.querySelectorAll('[data-document-type]');
        this.resultsContainer = this.documentPage.querySelector('.documents-container');
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.wordpressApiLink = "".concat(window.location.protocol, "//").concat(window.location.hostname, "/wp-admin/admin-ajax.php?action=documents_filter");
        this.typingTimeout = null;
        this.appliedSearchFilter = {};
        this.initializeSearchFromURL();
        this.addEventListeners();
    }
    DocumentFilter.prototype.initializeSearchFromURL = function () {
        var _this = this;
        // Set filter from page url if any are set
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        // Check if url has any params - set appliedFilters from url
        if (params.has('doc_cat') || params.has('term')) {
            params.forEach(function (filterValue, filterType) {
                if (filterType === 'term' && filterValue !== '') {
                    // if search & not empty
                    _this.appliedSearchFilter[filterType] = filterValue;
                }
                else if (filterValue !== '' && filterType !== 'term') {
                    // if not search & not empty
                    var array = filterValue.split(",");
                    _this.appliedSearchFilter[filterType] = array;
                }
                else {
                    // if no value - delete from url
                    var currentUrl_1 = new URL(window.location.href);
                    var params_1 = new URLSearchParams(currentUrl_1.search);
                    params_1.delete(filterType);
                    currentUrl_1.search = params_1.toString();
                    window.history.replaceState({}, '', currentUrl_1.toString());
                }
            });
            this.loadApiResults(); // Load results from api based on applied filters
            this.setFilterValues(); // Set active filter elements based on applied filters
        }
        else {
            // If no url parameter - load modules
            this.documentAccordionClass = new DocumentAccordion();
            this.documentViewerClass = new ViewDocument();
        }
    };
    DocumentFilter.prototype.setFilterValues = function () {
        var _this = this;
        // Set active elements on page load based on applied filters
        if (this.appliedSearchFilter.hasOwnProperty('term')) {
            // If has search filter - set search input value
            this.searchInput.value = this.appliedSearchFilter['term'];
        }
        this.documentTypes.forEach(function (filterValue) {
            // Get filter value from data attribute
            var value = filterValue.dataset.documentType;
            // Check if such filter type exist and if it has the value
            if (_this.appliedSearchFilter['doc_cat'] && _this.appliedSearchFilter['doc_cat'].includes(value)) {
                _this.documentPage.querySelector('[data-document-type="all"]').classList.remove('active');
                filterValue.classList.add('active');
            }
        });
    };
    DocumentFilter.prototype.addEventListeners = function () {
        var _this = this;
        this.searchInput.addEventListener('keyup', this.searchListener.bind(this));
        this.documentTypes.forEach(function (filter) { return filter.addEventListener('click', _this.documentTypesListener.bind(_this)); });
    };
    DocumentFilter.prototype.searchListener = function (event) {
        var _this = this;
        clearTimeout(this.typingTimeout);
        // Get the search query from the input
        this.searchQuery = this.searchInput.value;
        // Check if the user pressed the Enter key (key code 13)
        //@ts-ignore
        if (event.keyCode === 13) {
            // Perform the search or any other action here
            //performSearch(searchQuery);
            this.setFilter('term', this.searchQuery);
        }
        else {
            // Set a timeout to perform an action after the delimiter delay - set filter search parameters
            this.typingTimeout = setTimeout(function () { return _this.setFilter('term', _this.searchQuery); }, 1000);
        }
    };
    DocumentFilter.prototype.documentTypesListener = function (event) {
        // Set active filters on click
        var type = event.currentTarget;
        var isActive = type.classList.contains('active');
        var typeValue = type.dataset.documentType;
        var typesContainer = type.parentElement;
        if (isActive) {
            type.classList.remove('active');
            var isAnyActive = typesContainer.querySelector('.active') !== null;
            if (!isAnyActive) {
                // If no filter is active - set show all as active
                typesContainer.querySelector('[data-document-type="all"]').classList.add('active');
            }
        }
        else {
            type.classList.add('active');
            typesContainer.querySelector('[data-document-type="all"]').classList.remove('active');
        }
        if (typeValue === 'all') {
            var activeElements = typesContainer.querySelectorAll('.active');
            activeElements.forEach(function (element) { return element.classList.remove('active'); });
            typesContainer.querySelector('[data-document-type="all"]').classList.add('active');
        }
        this.setFilter('doc_cat', typeValue);
    };
    DocumentFilter.prototype.setFilter = function (type, value) {
        // Set filter values and type based on clicked value
        if (this.appliedSearchFilter.hasOwnProperty(type) && type !== 'term') {
            // Check if appliedFilter already exist such filter type
            var filterArray = this.appliedSearchFilter[type];
            var index = filterArray.indexOf(value);
            if (value === 'all') {
                // if clicked show all - delete filter type
                delete this.appliedSearchFilter[type];
            }
            else if (index === -1) {
                // If filter value doesn't exist, add it to the filterArray
                filterArray.push(value);
            }
            else {
                // If filterValue already exists, remove it from the filterArray
                filterArray.splice(index, 1);
                // If the filterArray is empty after removal, delete the filterType
                if (filterArray.length === 0) {
                    delete this.appliedSearchFilter[type];
                }
            }
        }
        else if (type === 'term' && value !== '') {
            // If filter type is search - update filter value
            this.appliedSearchFilter[type] = value;
        }
        else if (type === 'term' && value == '') {
            delete this.appliedSearchFilter[type];
        }
        else if (!this.appliedSearchFilter.hasOwnProperty(type) && value !== 'all') {
            // If filterType doesn't exist, create a new entry with an array containing filterValue
            this.appliedSearchFilter[type] = [value];
        }
        this.updatePageUrl(type, value);
        this.loadApiResults();
    };
    DocumentFilter.prototype.updatePageUrl = function (type, value) {
        // Update the URL with the new query parameters
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        if (type === 'term' && this.appliedSearchFilter.hasOwnProperty(type)) {
            // If filterType is search && filter is applied - set new value
            params.set(type, value.toString());
        }
        else if (type === 'term' && value === '') {
            params.delete(type);
        }
        else if (value === 'all') {
            // If filterValue is "all," remove specified filterType
            params.delete(type);
        }
        else if (this.appliedSearchFilter.hasOwnProperty(type)) {
            // if filter exists
            var postTypesQueryString = this.appliedSearchFilter[type].join(',');
            params.set(type, postTypesQueryString);
        }
        else if (!this.appliedSearchFilter.hasOwnProperty(type)) {
            // if not - remove param
            params.delete(type);
        }
        currentUrl.search = params.toString();
        window.history.replaceState({}, '', currentUrl.toString());
    };
    DocumentFilter.prototype.loadApiResults = function () {
        var _this = this;
        // Load results from api based on applied filters
        this.body.classList.add('no-scroll');
        this.pageOverlay.classList.add('visible');
        this.pageLoader.classList.add('active');
        this.resultsContainer.classList.add('loading');
        this.documentPage.scrollIntoView({ behavior: "smooth" });
        this.documentAccordionClass = null;
        this.documentViewerClass = null;
        var options = {
            method: 'POST',
            body: JSON.stringify(this.appliedSearchFilter)
        };
        fetch(this.wordpressApiLink, options)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            if (response.success === false) {
                _this.searchResults = response.data;
            }
            else {
                _this.searchResults = response;
            }
            _this.setDomElements();
        })
            .catch(function (error) {
            console.error('Fetch error:', error);
        })
            .finally(function () {
            _this.documentAccordionClass = new DocumentAccordion();
            _this.documentViewerClass = new ViewDocument();
            _this.body.classList.remove('no-scroll');
            _this.pageOverlay.classList.remove('visible');
            _this.pageLoader.classList.remove('active');
            _this.resultsContainer.classList.remove('loading');
        });
    };
    DocumentFilter.prototype.setDomElements = function () {
        var _a;
        this.resultsContainer.innerHTML = '';
        this.resultsContainer.innerHTML = (_a = this.searchResults) === null || _a === void 0 ? void 0 : _a.html;
    };
    return DocumentFilter;
}());
export default DocumentFilter;
